import {
  List,
  Datagrid,
  TextField,
  Pagination,
  BooleanField,
  TopToolbar,
  CreateButton,
  ResourceContextProvider,
} from 'react-admin';
import { Box, Breadcrumbs, Link, Typography } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useNavigate } from 'react-router-dom';
import { useRedirect } from 'react-admin';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { PageTitle } from '../../components/PageTitle';
import { CustomEmptyState } from '../../components/CustomEmptyState';

const FormsListActions = () => {
  const navigate = useNavigate();
  return (
    <TopToolbar>
      <CreateButton
        onClick={(e: React.MouseEvent) => {
          e.preventDefault();
          navigate('/configuration/forms/create');
        }}
      />
    </TopToolbar>
  );
};

const ConfigurationBreadcrumbs = () => {
  const redirect = useRedirect();
  return (
    <Box sx={{ p: 2, backgroundColor: '#f8f9fa', borderRadius: 1, mb: 2 }}>
      <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />}>
        <Link
          underline="hover"
          component="button"
          variant="body1"
          onClick={() => redirect('/configuration')}
          sx={{ cursor: 'pointer' }}
        >
          Configuration
        </Link>
        <Typography color="text.primary">Form Templates</Typography>
      </Breadcrumbs>
    </Box>
  );
};

export const FormsList = () => {
  const navigate = useNavigate();

  return (
    <>
      <PageTitle title="Form templates" icon={<AssignmentIcon />} />
      <ResourceContextProvider value="forms">
        <List
          title="Form templates"
          perPage={25}
          storeKey={false}
          pagination={<Pagination rowsPerPageOptions={[10, 25, 50, 100]} />}
          sort={{ field: 'name', order: 'ASC' }}
          actions={<FormsListActions />}
          empty={
            <CustomEmptyState
              resource="forms"
              title="No form templates yet."
              subtitle="Create a template for mobile data collection"
              actionText="Create form template"
              onAction={() => navigate('/configuration/forms/create')}
            />
          }
        >
          <ConfigurationBreadcrumbs />
          <Datagrid
            bulkActionButtons={false}
            rowClick={(_id, _resource, record) =>
              `/configuration/forms/${record.id}/show`
            }
          >
            <TextField source="name" />
            <BooleanField source="active" />
          </Datagrid>
        </List>
      </ResourceContextProvider>
    </>
  );
};
